import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Configuration } from "src/app/shared/configuration.enum";
import { FacadeService } from "src/app/shared/service-facade/facade.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class BrandProductSettingsResolver implements Resolve<boolean> {
  constructor(
    private facade: FacadeService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise<boolean>((res, rej) => {
      const product = this.facade.product;
      if (!product) { rej(false); return; }

      Promise.all([
        this.facade.getBrandSettings(environment.app_settings_version, product.brandId),
        this.facade.getBrandSettings(environment.app_settings_version, product.brandId, product.productUID)
      ]).then(async ([brandSettings, productSettings]) => {
        brandSettings.forEach(setting => {
          const { name, value } = setting;
          if (!name && !value) { return; }
          this.facade.addStorageItem(name!, value!);
        });


        const productSettingsMap: Map<string, unknown> = new Map();
        productSettings.forEach(setting => {
          const { name, value } = setting;
          if (!name && !value) { return; }
          this.facade.addStorageItem(name!, value!);
          productSettingsMap.set(name!, value);
        });

        this.facade.productSettings.set(this.facade.product!.productUID, productSettingsMap);

        this.facade.setBrandTheme();
        this.facade.addStorageItem(Configuration.ORIGINAL_TISA_URL, this.facade.getConfigurationSetting(Configuration.TISA_URL));

        await this.facade.getProductConfigurationByBrand(product);

        res(true);
      });
    });
  }
}
